import api from '../api';

export class EcommerceService {
  static async getEcommerceService(payload: any) {
    const {
      page,
      rowsPerPage,
      userType,
      startDate,
      endDate,
      search,
      domes,
      isSortByCreated,
      isSortByCategoryName,
    } = payload;
    const apiEndPoint = `limit=${rowsPerPage}&pageNo=${page + 1}${startDate !== '' && startDate !== undefined ? `&startDate=${startDate}` : ''}${endDate !== '' && endDate !== undefined ? `&endDate=${endDate}` : ''}${domes !== '' && domes !== undefined ? `&categoryId=${domes}` : ''}${userType !== '' && userType !== undefined ? `&status=${userType}` : ''}${search !== '' && search !== undefined ? `&search=${search}` : ''}${isSortByCreated !== undefined && isSortByCreated !== '' ? `&isSortByCreated=${isSortByCreated}` : ''}${isSortByCategoryName !== undefined && isSortByCategoryName !== '' ? `&isSortByCategoryName=${isSortByCategoryName}` : ''}`;
    return api.getApiCall(`/api/v1/admins/services-booking?${apiEndPoint}`);
  }

  static async sendEmail(payload: any) {
    const {
      sessionId,
      subject,
      message,
      userId,
    } = payload;
    const data = await api.postApiCall('/api/v1/admins/notifications/send-booking-notification', {
      sessionBookingId: sessionId,
      subject,
      message,
      userId,
    });
    return data;
  }

  static async sendPushNotification(payload: any) {
    const {
      sessionId,
      title,
      message,
      userId,
    } = payload;
    const data = await api.postApiCall('/api/v1/admins/notifications/send-booking-notification', {
      sessionBookingId: sessionId,
      title,
      message,
      userId,
    });
    return data;
  }

  static async sendSMS(payload: any) {
    const {
      sessionId,
      message,
      userId,
    } = payload;
    const data = await api.postApiCall('/api/v1/admins/notifications/send-booking-notification', {
      sessionBookingId: sessionId,
      message,
      userId,
    });
    return data;
  }

  static async export(payload: any) {
    const {
      page,
      rowsPerPage,
      status,
      search,
      isSortByCreated,
      isSortByCategoryName,
      type,
    } = payload;
    const apiEndPoint = `limit=${rowsPerPage}&pageNo=${page + 1}${status !== '' && status !== undefined ? `&status=${status}` : ''}${search !== '' && search !== undefined ? `&search=${search}` : ''}${isSortByCreated !== undefined && isSortByCreated !== '' ? `&isSortByCreated=${isSortByCreated}` : ''}${isSortByCategoryName !== undefined && isSortByCategoryName !== '' ? `&isSortByCategoryName=${isSortByCategoryName}` : ''}&type=${type}`;
    return api.getApiCall(`/api/v1/admins/services-product/export?${apiEndPoint}`);
  }

  static async getDomes() {
    return api.getApiCall('/api/v1/admins/categories/names');
  }
}
